import {Injectable} from "@angular/core";
import {IspmHttpClient} from "@ispm/core/services/ispm-http-client";
@Injectable()
export class SummaryTableWebService {
  constructor(private httpService: IspmHttpClient,) {}

  getTableData(endpoint:string,httpMethod:string, body:any){
    if(httpMethod == "Post"){
      return this.httpService.post(endpoint,body);
    }else if(httpMethod == "Get"){
      return this.httpService.get(endpoint);
    }else{
      throw new Error('HttpMethod '+httpMethod+' not supported');
    }

  }


}
